import type { ComponentProps } from "react";
import { joinClassNames } from "@/lib/classNames";
import styles from "./FormControls.module.css";

type InputProps = ComponentProps<"input"> & {
  variant?: "default" | "subtle" | "inline" | "code";
  visuallyHidden?: boolean;
};

export function Input({
  className,
  type = "text",
  variant = "default",
  visuallyHidden = false,
  ...props
}: InputProps) {
  return (
    <input
      data-slot="input"
      data-variant={variant}
      className={joinClassNames(styles.control, visuallyHidden && styles.visuallyHidden, className)}
      type={type}
      {...props}
    />
  );
}
